import Vue, { PropType } from 'vue';

import { E勘定科目カテゴリ } from '@/openapi/enum';

import { 大分類_販売管理費 } from '@/classes/common/Constants';

type Category大分類 = {
  category: E勘定科目カテゴリ;
  options: string[];
};

const category大分類s: Category大分類[] = [
  {
    category: E勘定科目カテゴリ.貸借,
    options: ['流動資産', '固定資産', '繰延資産', '流動負債', '固定負債', '株主資本', '評価･換算差額等', '新株予約権'],
  },
  {
    category: E勘定科目カテゴリ.損益,
    options: ['売上高', '売上原価', 大分類_販売管理費, '営業外収益', '営業外費用', '特別利益', '特別損失', '法人税等'],
  },
  {
    category: E勘定科目カテゴリ.製造原価,
    options: ['材料費', '労務費', '製造経費', '仕掛品'],
  },
];

export default Vue.extend({
  name: 'C勘定科目大分類Select',

  props: {
    category: {
      type: Number as PropType<E勘定科目カテゴリ>,
    },
    大分類: {
      type: String,
      default: '',
    },
    is販管費: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    opt大分類s(): string[] {
      if (this.is販管費) return [大分類_販売管理費];

      return category大分類s.find((c) => c.category === this.category)!.options;
    },
    selected: {
      get(): string {
        // 大分類の設定が無い場合は最初の項目を設定する
        if (this.大分類.length === 0) this.$emit('update:大分類', this.opt大分類s[0]);
        return this.大分類;
      },
      set(v: string): void {
        this.$emit('update:大分類', v);
      },
    },
  },
});
